module.exports = "/next-static/_next/static/images/hero_image_large-9d8599881d1fe84e681b9241daaadae3.webp";